import React, { useEffect, useState } from "react";
import { Typography, Button, Space, Card } from "antd";
import { CheckCircleOutlined, LockOutlined, LogoutOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const EmailConfirmedScreen = () => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    document.title = t('page.emailConfirmed.title', 'Email Confirmed');
  }, [t]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (countdown > 1) {
        setCountdown(countdown - 1);
      } else {
        handleLogout();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  const handleLogout = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("twoFactorAuthentication");
    window.location.href = "/userlogin";
  };

  const handlePasswordReset = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("twoFactorAuthentication");
    window.location.href = "/user_reset_password_setup";
  };

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 32 }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
          {t('page.emailConfirmed.header', 'Email Confirmed!')}
        </Title>
        <div style={{ textAlign: 'center' }}>
          <CheckCircleOutlined style={{ fontSize: 50, color: '#52c41a' }} />
        </div>
        <Paragraph style={{ marginTop: 16 }}>
          {t('page.emailConfirmed.message', 'Your email has been confirmed. You can now login to the application.')}
        </Paragraph>
        <Paragraph>
          {t('page.emailConfirmed.redirect', 'You will be redirected to the login page in {{countdown}} seconds...', { countdown })}
        </Paragraph>
        <Space size="middle" style={{ marginTop: 16 }}>
          <Button type="primary" icon={<LockOutlined />} onClick={handlePasswordReset}>
            {t('page.emailConfirmed.resetPassword', 'Reset my password')}
          </Button>
          <Button icon={<LogoutOutlined />} onClick={handleLogout}>
            {t('page.emailConfirmed.login', 'Go to Login')}
          </Button>
        </Space>
      </Card>
    </Space>
  );
};

export default EmailConfirmedScreen;
